// import React from "react";
// import Sidebar from "../components/Sidebar";
// import CompaniesNavbar from "../components/CompaniesNavbar";
// import CompaniesRegistration from "../components/CompaniesRegistration";
// import HiringCompanies from "../components/HiringCompanies";
// import CompaniesTable from "../components/CompaniesTable";
// import CompaniesHeader from "../components/CompaniesHeader";

// const CompaniesDashboard = () => {
//   return (
//     <div>
//       <Sidebar />
//       <CompaniesNavbar />
//       <CompaniesRegistration />
//       <HiringCompanies />
//       <CompaniesHeader />
//       <CompaniesTable />
//     </div>
//   );
// };

// export default CompaniesDashboard;
import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import CompaniesNavbar from "../components/CompaniesNavbar";
import CompaniesRegistration from "../components/CompaniesRegistration";
import HiringCompanies from "../components/HiringCompanies";
import CompaniesTable from "../components/CompaniesTable";
import CompaniesHeader from "../components/CompaniesHeader";

const CompaniesDashboard = () => {
  // State for filtering companies
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };

  return (
    <div>
      <Sidebar onSidebarStateChange={handleSidebarStateChange} />
      <CompaniesNavbar sidebarOpen={sidebarOpen} />
      <CompaniesRegistration sidebarOpen={sidebarOpen} />
      <HiringCompanies sidebarOpen={sidebarOpen} />
      <CompaniesHeader
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        sidebarOpen={sidebarOpen}
      />
      <CompaniesTable
        selectedStatus={selectedStatus}
        searchQuery={searchQuery}
        sidebarOpen={sidebarOpen}
      />
    </div>
  );
};

export default CompaniesDashboard;
